<template>
    <div class="b1t-okraina-main">
        <div class="container">
            
            <div class="top row">
                <div class="col">
                    <span class="link" @click="$router.push('actions')">Акции</span>
                </div>
                <div class="col">
                    <span class="link" @click="$router.push('catalog_new')">Новинки</span>
                    
                </div>
                <div class="col">
                    <span class="link" @click="$router.push('news')">Новости</span>
                </div>
            </div>

        </div>

        <b1t-okraina-main-slider/> 
        <b1t-okraina-main-menu-icons/>
        <b1t-okraina-catalog-sections v-bind:show_count="4"/>
        
    </div>
</template>

<script>

    import b1tOkrainaMainSlider from '../main/slider'
    import b1tOkrainaMainMenuIcons from '../main/menu-icons'
    import b1tOkrainaCatalogSections from '../catalog/sections'

    export default {
        name: 'b1t-okraina-main',
        components: {
            b1tOkrainaMainSlider,
            b1tOkrainaMainMenuIcons,
            b1tOkrainaCatalogSections
        },
        mounted(){
            this.$store.dispatch('SET_LOADING',false);
        },
        watch: {
            $route(to) {
                if(to.name === "main") {
                     this.$store.dispatch('SET_LOADING',false);
                }
            }
        }

    }
</script>

<style lang="scss">
    
    .b1t-okraina-main {
        .top {
            padding: 15px 0px 15px;

            .col {
                text-align: center;
               

                .link {
                    text-transform: uppercase;
                    color: #76B82B;
                    font-weight: 600;
                    font-size: 16px;
                }
            }
            
        }
    }

</style>